import {createFileRoute} from '@tanstack/react-router'

import SearchScreen from '@protected/search'

export const Route = createFileRoute('/_protected/search')({component: SearchScreen})
